<template lang="pug">
    .background-container(:style="style")
</template>
<script>
    export default {
        name: 'BackgroundImage',
        props: {
            imageAlignment: {
                type: String,
                required: true
            },
            image: {
                type: Object,
                required: true
            }
        },
        methods: {
            imageSrc() {
                return this.image.src
            }
        },
        computed: {
            style() {
                return 'background-size: cover; background-repeat: no-repeat; background-position: center; background-image:url(\'' + this.imageSrc() + '\');'
            }
        }
    }
</script>
<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins";
    .background-container
        height: 420px
        +mobile
            min-height: 250px
            width: 100%
            height: auto
</style>